import { Box, Stack } from '@chakra-ui/react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useEffect } from 'react';
import LoadingSpinner from 'components/LoadingSpinner';
import { FormBodyProps } from 'types/common';
import Switch from 'components/Form/Switch';
import DatePicker from 'components/Form/Date';

function FormBody({ isLoading }: FormBodyProps) {
  const { control, setValue } = useFormContext();
  const [isBanned] = useWatch({
    control,
    name: ['isBanned'],
  });

  useEffect(() => {
    if (isBanned) {
      setValue('banRemovalDate', null);
      setValue('isOutOfLoyaltyProgram', true);
    }
  }, [isBanned, setValue]);

  return (
    <Box w="100%">
      {isLoading && <LoadingSpinner />}
      <Stack spacing={4}>
        <Switch
          name="isOutOfLoyaltyProgram"
          label="Wyłączony z programu lojalnościowego"
        />
        <Switch name="isBanned" label="Zbanowany" />
        <DatePicker
          name="banRemovalDate"
          label="Data automatycznego ściągnięcia bana"
          disabled={!isBanned}
          showError
          showTimeInput
        />
        <DatePicker
          name="loyaltyProgramJoinDate"
          label="Data dołączenia do programu lojalnościowego"
          disabled
        />
      </Stack>
    </Box>
  );
}

export default FormBody;
